export function gameMeta(title, description, draft = false) {
  return {
    meta: [
      { vmid: "og:type", property: "og:type", content: "website" },
      {
        vmid: "og:image",
        property: "og:image",
        content: "https://www.ari.company/games/ludomelix/release-1/social.jpg",
      },
      { vmid: "og:image:width", property: "og:image:width", content: "1200" },
      { vmid: "og:image:height", property: "og:image:height", content: "630" },
      {
        vmid: "twitter:card",
        name: "twitter:card",
        content: "summary_large_image",
      },
      ...(draft
        ? [{ vmid: "robots", name: "robots", content: "noindex, nofollow" }]
        : []),
    ],
  };
}
